import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "../hooks/apiRequest";
import { TaskProps, TaskStatus, Severity, Priority } from "../types/interfaces";
import { taskKeys } from "../utils/queryKeys";

export function useAddSubtask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { title: string; assigneeId?: string; storyPoints?: number; severity?: Severity; priority?: Priority }) =>
      (await apiRequest<TaskProps>(`tasks/${taskId}/subtasks`, {
        method: "POST",
        body: JSON.stringify(data),
      })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  });
}

export function useUpdateSubtask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      subtaskId,
      ...data
    }: {
      subtaskId: string;
      status?: TaskStatus;
      severity?: Severity;
      priority?: Priority;
      assigneeId?: string | null;
    }) =>
      (await apiRequest<TaskProps>(`tasks/${taskId}/subtasks/${subtaskId}`, {
        method: "PUT",
        body: JSON.stringify(data),
      })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  });
}

export function useDeleteSubtask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (subtaskId: string) =>
      (await apiRequest<TaskProps>(`tasks/${taskId}/subtasks/${subtaskId}`, { method: "DELETE" })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  });
}
